import {cloneDeep} from "lodash"
import qs from "qs"
import {APIRequestConfig} from "../../../API"

export default function addHeaders(config: APIRequestConfig = {}, Etag = "") {
  const options: APIRequestConfig = cloneDeep(config)

  if (!options.headers) {
    options.headers = {}
  }

  if (Etag) {
    options.headers["If-Match"] = Etag
  }

  if (config.addCSRF) {
    /* eslint-disable quotes */
    const csrfElement: any = document.querySelector(`meta[name="csrf"]`)
    /* eslint-enable quotes */
    if (csrfElement) {
      options.headers["csrf-token"] = csrfElement.content
    }
  }

  if (!options.paramsSerializer) {
    options.paramsSerializer = (params: any) => qs.stringify(params, {arrayFormat: "repeat", skipNulls: true})
  }

  return options
}
